<template>
    <div class="signature-container" ref="signatureContainer">
        <div class="signature-tip">请于下方签名</div>
        <!-- 全屏横板签名画布 -->
        <div class="BorHead">
            <canvas ref="signatureCanvas" class="signature-canvas" @mousedown="startDraw" @mousemove="drawing"
                @mouseup="endDraw" @mouseleave="endDraw" @touchstart="handleTouchStart" @touchmove="handleTouchMove"
                @touchend="handleTouchEnd"></canvas>
        </div>
        
        <!-- 底部操作按钮栏 -->
        <div class="signature-footer">
            <button class="signature-btn back-btn" @click="backSignature">返回</button>
            <button class="signature-btn clear-btn" @click="clearSignature">清除</button>
            <button class="signature-btn confirm-btn" @click="confirmSignature">确认</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SignatureBoard",
        data() {
            return {
                isDrawing: false, // 是否正在绘制
                canvas: null, // canvas 实例
                ctx: null, // canvas 2d 上下文
                lastX: 0, // 上一次绘制的X坐标
                lastY: 0, // 上一次绘制的Y坐标
                lineWidth: 3, // 签名线条宽度
                lineColor: "#000000", // 签名线条颜色
            };
        },
        mounted() {
            // 组件挂载后初始化 canvas
            this.initCanvas();
            // 监听窗口大小变化，重新适配 canvas 尺寸
            window.addEventListener("resize", this.initCanvas);
        },
        beforeDestroy() {
            // 组件销毁前移除窗口监听，防止内存泄漏
            window.removeEventListener("resize", this.initCanvas);
        },
        methods: {
            /**
             * 初始化 canvas （设置尺寸、获取上下文、配置样式）
             */
            initCanvas() {
                this.canvas = this.$refs.signatureCanvas;
                if (!this.canvas) return;
                this.ctx = this.canvas.getContext("2d");
                // 设置 canvas 为横板全屏（去除滚动条，底部预留按钮高度）
                const container = this.$refs.signatureContainer;
                const footerHeight = 60; // 底部按钮栏高度，与 css 对应
                this.canvas.width = window.innerWidth-10;
                this.canvas.height = window.innerHeight - footerHeight-50;
                // 清空画布（初始化空白画布）
                this.clearCanvas();
                // 配置画笔样式
                this.ctx.lineWidth = this.lineWidth;
                this.ctx.lineCap = "round"; // 线条两端圆润
                this.ctx.lineJoin = "round"; // 线条拐角圆润
                this.ctx.strokeStyle = this.lineColor;
            },

            /**
             * 清空 canvas 画布
             */
            clearCanvas() {
                if (!this.ctx) return;
                this.ctx.fillStyle = "#ffffff"; // 画布背景色（白色）
                this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
            },

            // ===== 鼠标事件（PC 端）=====
            /**
             * 鼠标按下：开始绘制
             */
            startDraw(e) {
                this.isDrawing = true;
                // 获取鼠标在 canvas 内的坐标（修正偏移）
                const {
                    x,
                    y
                } = this.getCanvasPos(e);
                this.lastX = x;
                this.lastY = y;
            },

            /**
             * 鼠标移动：绘制线条
             */
            drawing(e) {
                if (!this.isDrawing) return;
                const {
                    x,
                    y
                } = this.getCanvasPos(e);

                // 开始绘制路径
                this.ctx.beginPath();
                // 从上次坐标移动到当前坐标
                this.ctx.moveTo(this.lastX, this.lastY);
                this.ctx.lineTo(x, y);
                // 描边（显示线条）
                this.ctx.stroke();
                // 更新上次坐标
                this.lastX = x;
                this.lastY = y;
            },

            /**
             * 鼠标抬起/离开：结束绘制
             */
            endDraw() {
                this.isDrawing = false;
            },

            // ===== 触摸事件（移动端适配）=====
            /**
             * 触摸开始
             */
            handleTouchStart(e) {
                e.preventDefault(); // 阻止默认滚动行为
                const touch = e.touches[0]; // 获取第一个触摸点
                this.startDraw(touch);
            },

            /**
             * 触摸移动
             */
            handleTouchMove(e) {
                e.preventDefault();
                const touch = e.touches[0];
                this.drawing(touch);
            },

            /**
             * 触摸结束
             */
            handleTouchEnd(e) {
                e.preventDefault();
                this.endDraw();
            },

            /**
             * 获取坐标（修正 canvas 偏移，返回相对 canvas 的 x/y）
             */
            getCanvasPos(e) {
                const rect = this.canvas.getBoundingClientRect();
                return {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top,
                };
            },
            // ===== 底部按钮功能 =====
            /**
             * 按钮：返回
             */
            backSignature(){
                this.clearCanvas();
                this.$emit("back","");
            },
            /**
             * 清除按钮：清空签名
             */
            clearSignature() {
                this.clearCanvas();
            },

            /**
             * 确认按钮：生成 base64 并返回
             */
            confirmSignature() {
                if (!this.canvas) return;
                // 生成 base64 图片（png 格式，质量无损；如需压缩可改用 jpeg 并配置质量参数）
                const base64Url = this.canvas.toDataURL("image/png");
                // 方式1：通过 $emit 向父组件传递 base64 地址（推荐，符合 Vue 组件通信规范）
                this.$emit("Suc", base64Url);
                // 方式2：如果需要直接返回（可用于同步调用），也可以返回该值（或存入全局变量）
                // return base64Url;
            },
        },
    };
</script>

<style scoped>
    /* 全屏容器 */
    .signature-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #f5f5f5;
        overflow: hidden;
    }
    .signature-tip {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        color: #333;
        font-weight: 500;
        background-color: #f5f5f5;
    }
    .BorHead{
        border: 1px dashed #ddd;
        margin: 5px;
    }
    /* 签名画布 */
    .signature-canvas {
        display: block;
        /* 去除 canvas 默认内边距，防止偏移 */
        background-color: #ffffff;
        cursor: crosshair;
        /* PC 端鼠标样式（十字准星） */
    }

    /* 底部按钮栏 */
    .signature-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 60px;
        background-color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        /* 按钮之间的间距 */
    }

    /* 按钮样式 */
    .signature-btn {
        padding: 10px 25px;
        border: none;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        color: #ffffff;
        transition: background-color 0.3s ease;
    }

    .clear-btn,.back-btn{
        background-color: #666666;
    }

    .clear-btn:hover {
        background-color: #888888;
    }

    .confirm-btn {
        background-color: #1890ff;
    }

    .confirm-btn:hover {
        background-color: #40a9ff;
    }
</style>